import './form.css'
import './tabbed-form.css'
import React from 'react'
import PropTypes from 'prop-types'

import { cn } from 'utils'

import { Form } from './form'
import { ValidationMessage } from './validation-message'
import { FormFieldEmitter, FormPropsContext } from './context'

export class TabbedForm extends Form {
  static propTypes = {
    ...super.propTypes,
    parse: PropTypes.func,
  }

  fieldTabMap = {}

  registerFieldTab = (name, tab) => {
    if (name && tab) {
      this.fieldTabMap[name] = tab
    }
  }

  /** @private */
  setFieldStatus = ({
    value = null,
    name,
    enable = true,
    defaultValue = null,
    validationMessage,
    touched,
    ref,
  } = {}) => {
    if (!name) throw 'field name is undefined'
    this.setStateAsync({ wasSubmitted: false })
    if (ref) {
      this.fieldRefs[name] = ref
    }

    return this.updateFieldState(name, {
      value,
      touched,
      validationMessage,
      defaultValue,
      enable,
    }).then(() => {
      this.props.onChange && this.props.onChange(this.getValues())
    })
  }

  handleSubmit = async (event) => {
    await this.setStateAsync({ wasSubmitted: false })
    event.preventDefault()
    event.stopPropagation()
    this.validate().then(
      () => this.doSubmit(),
      () => this.focusFirstInvalidField(),
    )
    await this.setStateAsync({ wasSubmitted: true })
  }

  async setErrors(error, errors) {
    if (this._unmounted) return
    if (!errors || !Object.keys(errors).length) {
      await this.setStateAsync(() => ({ error, pending: false }))
      return
    }
    await this.setStateAsync((state) => {
      const nextFields = { ...state.fields }
      const unhandledMessages = []
      Object.entries(errors).forEach(([name, validationMessage]) => {
        //TODO: Refactor this part
        const parse = this.props.parse
        let nestedKey
        if (parse) {
          nestedKey = parse(name)
        }
        if (nextFields.hasOwnProperty(nestedKey ?? name)) {
          nextFields[nestedKey ?? name] = {
            ...nextFields[nestedKey ?? name],
            validationMessage,
            touched: true,
          }
        } else {
          unhandledMessages.push(`${validationMessage} (${nestedKey ?? name})`)
        }
      })

      const nextState = { fields: nextFields, pending: false }

      if (unhandledMessages) {
        nextState.error = [error, ...unhandledMessages].filter(Boolean).join(', ')
      } else {
        nextState.error = error
      }

      return nextState
    })
  }

  //TODO: Probably redundant code
  // async validate() {
  //   if (this.hasInvalidField()) {
  //     await this.resetTouched(true)
  //     await this.setStateAsync(() => ({
  //       error: 'The form is not valid. Please check for errors on each tab',
  //     }))
  //     throw new Error('fail')
  //   }
  //   const error = await this.getCustomValidationError()
  //   await this.setStateAsync(() => ({ error }))
  //   if (error) {
  //     throw new Error('fail')
  //   }
  // }

  getFirstInvalidAndVisibleFieldName(fields = this.state.fields) {
    for (const [name, state] of Object.entries(fields)) {
      const ref = this.fieldRefs[name]
      if (state.validationMessage && ref?.element?.offsetWidth) {
        return name
      }
    }
  }

  //TODO: Probably redundant code
  // focusFirstInvalidField() {
  //   const name = this.getFirstInvalidAndVisibleFieldName()
  //   const ref = this.fieldRefs[name]
  //   const formTab = ref?.element?.closest('.form-tab')
  //   // if (!ref?.element?.offsetWidth) {
  //   //   this.errorMessageRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  //   // }
  //   if (formTab?.classList?.contains('hidden')) {
  //     return this.errorMessageRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  //   }
  //   if (ref?.focus) {
  //     return ref.focus()
  //   }
  //   if (ref?.scrollIntoView) {
  //     return ref.scrollIntoView({ behavior: 'smooth' })
  //   } else {
  //     this.errorMessageRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  //   }
  // }

  render() {
    const {
      onSubmit,
      children,
      onChange,
      redirect,
      className,
      validation,
      readOnly,
      defaultValues,
      disabled,
      name,
      ...props
    } = this.props

    const { error, pending, fields, wasSubmitted } = this.state

    const modified = this.hasModifiedField()
    const values = this.getValues()
    const valid = this.isValid()
    const invalidFields = Object.entries(fields)
      .filter(([, { validationMessage }]) => !!validationMessage)
      .map(([name]) => name)
    const registerFieldTab = this.registerFieldTab
    const fieldTabMap = this.fieldTabMap
    const firstInvalidField = this.getFirstInvalidAndVisibleFieldName()

    // console.log('modified', modified)
    // console.log('values', values)
    // console.log('valid', valid)

    return (
      <form
        lang="en"
        {...props}
        name={name}
        id={props?.id ?? name}
        onSubmit={this.handleSubmit}
        ref={this.element}
        onReset={this.handleReset}
        className={cn(className, 'form', 'tabbed-form')}
        noValidate
      >
        <ValidationMessage error ref={this.errorMessageRef}>
          {(!this.hasInvalidField() && error) || null}
        </ValidationMessage>

        <FormFieldEmitter.Provider value={this.setFieldStatus}>
          <FormPropsContext.Provider
            value={{
              readOnly,
              defaultValues,
              disabled,
              pending,
              modified,
              valid,
              values,
              fields,
              wasSubmitted,
              invalidFields,
              registerFieldTab,
              fieldTabMap,
              firstInvalidField,
            }}
          >
            {children}
          </FormPropsContext.Provider>
        </FormFieldEmitter.Provider>
      </form>
    )
  }
}

TabbedForm.propTypes = {}
